import {useEffect} from 'react';
import HeadLegend from 'components/HeadLegend';
import appStyle from 'App.module.css';
import {useAppSelector} from 'hooks';
import {selectScreen, startAuth} from 'auth/authSlice';
import Loader from 'components/Loader';
import cx from 'clsx';

import {Helmet} from 'react-helmet-async';

import { useTenantId } from 'hooks/useTenantId';

import { useIsDownSm } from 'hooks/useMediaQueries';

import { TenantLogo } from 'components/TenantLogo/TenantLogo';

import { PoweredByEnnabl } from 'components/PoweredByEnnabl';

import ContactUs from 'components/ContactUs/ContactUs';

import VerificationCode from './VerificationCode';
import style from './SignUp.module.css';
import {useAppDispatch} from '../../store';


const SignUp = () => {
  const isDownSm = useIsDownSm();
  const tenantId = useTenantId();
  const dispatch = useAppDispatch();
  const screen = useAppSelector(selectScreen);

  useEffect(() => {
    if (screen.screenType === 'ENTRY_SCREEN') {
      dispatch(startAuth(true));
    }
  }, [screen.screenType, dispatch]);

    return (
    <div className={appStyle.contentWrapper}>
      <Helmet>
        <title>Sign Up - Ennabl</title>
      </Helmet>
    {tenantId && !isDownSm && <TenantLogo className={appStyle.tenantLogo} />}
    <div className={cx(appStyle.content, style.signUpContainer)}>
      {['ENTRY_SCREEN', 'AUTHORIZED'].includes(screen.screenType) ? (
        <div className={appStyle.loaderContainer}>
          <Loader />
        </div>
      ) : (
        <>
          <HeadLegend />

          <VerificationCode />

          <ContactUs type='SIGN_UP' />

          {tenantId && isDownSm && <div className={appStyle.poweredBy}><PoweredByEnnabl /></div>}
        </>
      )}
    </div>
    </div>
  );
};

export default SignUp;
